<template>
  <div class="homepage" v-if="loaded">


    <hero :promoted="promoted"></hero>

    <section id="categories_list" class="centered" style="direction:ltr; text-align:left;" dir="ltr">
      <div class="category_strip" v-for="cat in categories" :key="cat.id">
          <router-link :to="'category/' + cat.id" class="strip_title"><span>{{cat.name}}</span></router-link>
          <carousel class="owl-rtl" :autoplay="false" :responsive="{0:{items:2,nav:true},1100:{items:3,nav:true},1400:{items:4,nav:true}}" :margin="10" :rtl="true" :nav="true" :dots="false" :navText="['<div class=nav_right></div>','<div class=nav_left></div>']" >
            
            <itemTpl v-for="item in cat.items" :item="item" :key="item.id" />
            
          </carousel>
      </div>
    </section> 

  </div>
</template>


<script>
import carousel from 'vue-owl-carousel'
//import { constants } from 'crypto';
import itemTpl from './item_tpl.vue'
import hero from './hero_items.vue'



export default {
  components: { carousel, itemTpl, hero },

  data() {
    return {
      new_setup: false,
      promoted: [],
      categories: [], 
      muted: true,
      loaded: false
    };
    
    
  },
  methods: {
    
    hero_pages_change(num){

      for (var i in this.promoted)
      {
        this.promoted[i].is_active = (i == num);
      }
      
    },
    
    parse_homepage_data: function(data, save_to_store){

      // promoted
      for (var i in data.promoted)
      {
        data.promoted[i].is_active = (i == 0);
      }
      this.promoted = data.promoted;

      // Categories
      for (let i_cat in data.categories)
      {
        for (let i_item in data.categories[i_cat].items)
        {
          data.categories[i_cat].items[i_item].loadVideo = false;
        }
      }
      this.categories = data.categories;

      if (save_to_store === true)
      {
        for (let i in this.promoted)
        {
          this.$store.commit('update_item', this.promoted[i]);
        }
      }
    }


  },
  updated: function () {
      window.dispatchEvent(new Event('resize'));

  },
  mounted: function() {

    var self = this

    if (this.$store.state.homepage_data.promoted != undefined)
    { 
      this.parse_homepage_data(this.$store.state.homepage_data);
      self.loaded = true;
    }
    else
    {
      self.$emit('show_loader');
      // categories
      this.api_call({ url: 'home', data: { include_rel_items: false }, onComplete: function(data){

        self.$store.state.homepage_data = data.data.data;

        self.parse_homepage_data(data.data.data, false);
        
        self.$emit('loaded');
        self.loaded = true;

      } } );
    }
  }
}
</script>